import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { TwEnvioMuestraLaboratorioSolicitudExViewModel, SolicitudLaboratorioExViewModel } from '../laboratorioEx.types';
import { RegLaboratorioViewModel } from '../../../../_mantenimiento/registros/laboratorios/laboratorio.types';
import { RegLaboratorioService } from '../../../../_mantenimiento/registros/laboratorios/laboratorio.service';
import { DatePipe } from '@angular/common';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { UsuariosService } from '../../../../_mantenimiento/usuarios/usuarios.service';

@Component({
    selector: 'app-laboratorioex-datos',
    templateUrl: './laboratorioex-datos.component.html',
})
export class LaboratorioExDatosComponent extends ComponentBase implements OnInit, OnChanges {
    public isCollapsedCabecera = false;

    laboratorio = '';
    fecha: Date;
    observaciones = '';

    @Input() idSolicitudEx = 0;
    @Input() formGroup: FormGroup;
    @Input() usuarioId = 0;
    @Input() usuarioIdDescripcion = '';
    @Input() usuarioAsociadoEnvioId = 0;
    @Input() usuarioAsociadoEnvioDescripcion = '';
    @Input() solicitudLaboratorioEx: SolicitudLaboratorioExViewModel;
    @Input() esPerfilInspector = false;
    @Input() esPerfilConsultasyLaboratorio = false;
    @Input() listLaboratorios: RegLaboratorioViewModel[];
    @Input() hayEnvioMuestrasInspectorEx = false;
    @Input() envioMuestrasEx: TwEnvioMuestraLaboratorioSolicitudExViewModel;
    @Input() enviandoMuestrasEx = false;

    constructor(
        private regLaboratorioService: RegLaboratorioService,
        public datepipe: DatePipe,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private usuariosService: UsuariosService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        if (!this.hayEnvioMuestrasInspectorEx) {
            this.formGroup.patchValue({
                IdUsuario: this.usuarioId,
                IdUsuarioDescripcion: this.usuarioIdDescripcion, //Inspector con nombre y apellidos
            });
        }

        this.form = this.formGroup;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.envioMuestrasEx?.currentValue) {
            if (this.hayEnvioMuestrasInspectorEx) {
                this.formGroup.controls['ObservacionesEnvio'].disable();
                this.getSolicitudLaboratorioExData();
            }
        }
    }

    getSolicitudLaboratorioExData() {
        this.regLaboratorioService.getLaboratorio(this.envioMuestrasEx?.IdLaboratorio).subscribe(res => {
            this.laboratorio = res?.RazonSocial;
        });

        this.usuariosService.getUsuarioCexveg(this.usuarioAsociadoEnvioId!).subscribe(usuario => {
            this.usuarioAsociadoEnvioDescripcion = `${usuario.Nombre} ${usuario.Apellidos}`;
            this.updateForm();
        });

        this.fecha = this.envioMuestrasEx?.FechaEnvio;
        this.observaciones = this.envioMuestrasEx?.ObservacionesEnvio;
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            IdUsuario: this.usuarioAsociadoEnvioId,
            IdUsuarioDescripcion: this.usuarioAsociadoEnvioDescripcion, //Inspector con nombre y apellidos
            IdLaboratorio: null, //Desplegable de Laboratorios Activos
            IdLaboratorioEnvioMuestrasSolicitudEx: this.laboratorio, //Si hay Envío de Muestras, el Laboratorio (descripción) que se haya seleccionado para la Solicitud
            FechaEnvio: this.datepipe.transform(this.fecha, 'dd/MM/yyyy') || null, //Fecha en la que el usuario guarde
            ObservacionesEnvio: this.observaciones || '',
        });
    }
}
